import React, { useState, useEffect } from 'react';
import apiUrl from '../Apiurl';
import prodVuoto from '../prodottoVuoto';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

function CodiceVSVoceCliccabile3({
  codVS,
  codPS,
  codProd,
  shortName,
  setProductFunction,
  utente,
  tit,
  imm
}) {

  const { user, /* isAuthenticated,  */getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");

  const data = {
    codiceVS: codVS,
    codicePS: codPS,
    codiceProduttore: codProd,
    shortName: shortName,
    tit: tit,
    imm: imm
  }

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };
    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);


  const handleSubmit = (e) => {
    if (!token) {
      console.warn("sto aspettando un token")
      return;
    }
    if (!utente.permessiAPI["update:database"] && utente.permessiAPI["update:dbrevisioni"]) {

      const config = {
        headers: {
          'Authorization': 'Bearer ' + token,
        },
      }
      axios.post(apiUrl + "/prodotti/prodotto/showORcreateIDPSREV3", data, config)
        .then(data => setProductFunction(data.data[0] || prodVuoto))
        .then(e.preventDefault())
    } else if (utente.permessiAPI["update:database"]) {

      const config = {
        headers: {
          'Authorization': 'Bearer ' + token,
        },
      }
      axios.post(apiUrl + "/prodotti/prodotto/showORcreateIDPS3", data, config)
        .then(data => setProductFunction(data.data[0] || prodVuoto))
        .then(e.preventDefault())
    }
  }


  return (
    <span className="pointer" onClick={handleSubmit}>
      <strong>{codVS}</strong>
    </span>
  )
}


export default CodiceVSVoceCliccabile3;



